export const Divider = {}

export default Divider
